import './InputGrid.css';
import { ReactNode } from 'react';

export const halfRow = 'grid-halv-row';

type InputGridProps = { className?: string; children: ReactNode };
export const InputGrid = ({ className, children }: InputGridProps) => {
	return <input-grid class={className}>{children}</input-grid>;
};
